import React from "react";
import { cn } from "./ui/utils";

export function RichTextContent({
  html,
  className,
  style,
}: {
  html?: string | null;
  className?: string;
  style?: React.CSSProperties;
}) {
  const customStyle: React.CSSProperties = {
    fontSize: style?.fontSize || "16px",
    color: style?.color || "#2d3748",
    lineHeight: style?.lineHeight || "2.2",
    textAlign: style?.textAlign || "justify",
    wordBreak: style?.wordBreak || "break-word",
    fontFamily: "inherit"
  };

  return (
    <div 
      className={cn("rich-content", className)} 
      style={style}
    >
      <div 
        className="ql-editor" 
        style={customStyle}
        dangerouslySetInnerHTML={{ __html: html || "" }} 
      />
    </div>
  );
}

